import React from 'react';
import { useTranslation } from 'react-i18next';

interface TopNavigationBarProps {
  testId?: string;
  className?: string;
  selectedIndex?: number;
  menus?: Array<{ text: string; context: string }>;
  setNavigationIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const defaultMenus = [
  { text: 'settlement.navigation.predictionSettlement', context: 'operation' },
  { text: 'settlement.navigation.auctionSettlement', context: 'operation' },
];

export const TopNavigationBar: React.FC<TopNavigationBarProps> = ({
  testId,
  className,
  selectedIndex,
  menus,
  setNavigationIndex,
}) => {
  const { t } = useTranslation();
  const selectedClass =
    'noto-13-bold text-dark-6 border-b-2 border-teal-main pt-[20px] pb-[18px]';
  const defaultClass = 'noto-13-normal text-dark-6 py-[20px]';

  return (
    <nav data-testid={testId} className={`${className}`}>
      <div className="flex">
        {(menus ?? defaultMenus).map((menu, index) => {
          return (
            <div
              key={index}
              className={`${index === selectedIndex ? selectedClass : defaultClass} ml-[50px] flex w-fit cursor-pointer items-center justify-center px-[12px]`}
              onClick={() => setNavigationIndex?.(index)}
            >
              {t(menu.text, {
                context: menu.context,
              })}
            </div>
          );
        })}
      </div>
    </nav>
  );
};
